module.exports = __webpack_public_path__ + "img/10.8ea70a9c.png";